import { PropTypes } from "prop-types"

export function OptionPlusMinusLabel(props) {
  const { children, labelId } = props

  return (
    <div className="oj-option-plus-minus-label" id={labelId}>
      {children}
    </div>
  )
}

OptionPlusMinusLabel.propTypes = {
  children: PropTypes.node.isRequired,
  labelId: PropTypes.string.isRequired
}

export default OptionPlusMinusLabel
